import { PlainModal } from '@client/new/components/Modal/Modal';
import ReactPlayer from 'react-player';

export const EducationalVideoModal = (p: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  return (
    <PlainModal
      isOpen={p.isOpen}
      onClose={p.onClose}
      height={'auto'}
      sx={{
        width: '560px !important',
      }}
    >
      {/* TODO add correct video*/}
      <ReactPlayer
        url={
          'https://stream.mux.com/cJVA8zjj6SEbZ00gdSjXAAC011s02EQxIEzM5E017BIlsxM.m3u8'
        }
        width={'100%'}
        height={'auto'}
        config={{
          file: {
            attributes: {
              poster:
                import.meta.env.BASE_URL +
                'static/images/custom-domain-tutorial.png',
            },
          },
        }}
        controls={true}
        playsinline
      />
    </PlainModal>
  );
};
